import { motion, type Variants } from "motion/react";
import { consoles } from "../consoles";
import { ConsoleLogo } from "../components/ConsoleLogo";
import { Reveal, useReducedMotion } from "./motion";

const grid: Variants = {
  hidden: {},
  show: { transition: { staggerChildren: 0.04 } },
};
const tile: Variants = {
  hidden: { opacity: 0, y: 18, scale: 0.96 },
  show: { opacity: 1, y: 0, scale: 1, transition: { duration: 0.4, ease: "easeOut" } },
};

export function ConsoleWall() {
  const reduced = useReducedMotion();

  return (
    <section className="relative mx-auto max-w-6xl px-5 py-24">
      <Reveal className="text-center">
        <p className="lp-section-label">The library</p>
        <h2 className="lp-pixel mt-4 text-[1.6rem] leading-tight text-text-primary sm:text-[2.4rem]">
          ONE APP, <span className="lp-neon">FIFTEEN SYSTEMS</span>
        </h2>
        <p
          className="lp-term mx-auto mt-4 max-w-[44ch] text-[1.3rem]"
          style={{ color: "var(--crt-ink-dim)" }}
        >
          15 systems. NES to WonderSwan. All in your browser, in the call.
        </p>
      </Reveal>

      <motion.ul
        variants={grid}
        initial={reduced ? undefined : "hidden"}
        whileInView={reduced ? undefined : "show"}
        viewport={{ once: true, amount: 0.15 }}
        className="mt-12 grid list-none grid-cols-2 gap-3 p-0 sm:grid-cols-3 lg:grid-cols-5"
      >
        {consoles.map((c) => (
          <motion.li key={c.id} variants={tile} className="lp-card">
            <span
              className="flex w-full items-center justify-center"
              style={{ height: "3rem" }}
            >
              <ConsoleLogo logo={c.logo} emoji={c.emoji} name={c.name} plate={c.logoPlate} />
            </span>
            <span className="text-center text-sm font-semibold text-text-primary">
              {c.name}
            </span>
          </motion.li>
        ))}
      </motion.ul>
    </section>
  );
}
